window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      if ($(window).width() < 768) {
        payload.search.configs.general.noOfProducts = 22;
      }
      payload.search.configs.pagination.infiniteScrollOffset = {
        mobile: "2000",
        desktop:"600"
      };

      if (
        window.wizzyCustom === "collection" ||
        window.wizzyCustom === "index"
      ) {
        $("body").addClass("wizzy-custom");
      }

      payload.common.lazyDOMConfig.searchInputIdentifiers = [];
      payload.common.lazyDOMConfig.searchInputIdentifiers.push({
        dom: ".Search__Input",
        type: "text",
      });
      payload.common.lazyDOMConfig.contentDOMIdentifiers = [
        "#main",
        ".index-sections",
      ];
      return payload;
    }
  );
  $(document).ready(function () {
    searchSubmit();
    wizzyCcroll();
    replaceTemplate("wizzy-search-results-product");
    replaceTemplate("wizzy-autocomplete-topproducts");
  });
  // window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  //   function (payload) {
  //     payload.filters.productsCount = 9;
  //     payload.filters.swatch = [];
  //     payload.filters.sort = [
  //       { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" },
  //     ];
  //     console.log(payload);

  //     return payload;
  //   }
  // );

  //   window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
  //   function (payload) {
  //     payload.filters.productsCount = 9;
  //     payload.filters.swatch = [];
  //     payload.filters.sort = [
  //       { field: "product_wizzy-best-selling_sortOrder:float", order: "asc" },
  //     ];
  //     console.log(payload);

  //     return payload;
  //   }
  // );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (productList) {

      productList.forEach((product)=>{
        product.isValidPrice=parseFloat(product.sellingPrice)>0;
        
        return product;
      })
      
      return productList;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      $(".wizzy-view-all-products").on("click", function () {
        var e = $.Event("keyup", { keyCode: 13 });
        $(this).trigger(e);
      });
      let total = payload.data.response.payload.products.total;
      if (total) {
        $(".wizzy-view-all-products")
          .html(`<p>View All ${total} Products</p> <a href="#" class="wizzy-search-back"><span class="wizzy-icon"></span></a>`);
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      console.log(payload, typeof payload);
      if(Object.keys(payload).length == 0) {
        if($("#section-header").hasClass("Header--transparent")) {
          $("body").addClass("wizzy-add-margin");
        } else {
          $("body").removeClass("wizzy-add-margin");
        }
      }
      if (window.wizzyCustom === "index") {
        $("#section-header").css({
          "box-shadow": "0 -1px var(--header-border-color) inset",
        });
      }
      onHoverAddToCart();
      return payload;
    }
  );
};

function replaceTemplate(div) {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
}

function mobileSearchFeature() {
  const search = document.getElementsByClassName("Search__Input")[0];

  search.addEventListener("click", () => {
    if ($(window).width() < 768) {
      document
        .getElementsByClassName("wizzy-search-form-wrapper")[0]
        .classList.add("mobileTapped");
      document
        .getElementsByClassName("input-text search-query wizzy-search-input")[0]
        .click();
    }
  });
}

function searchSubmit() {
  $(document).on("keyup", function (event) {
    if (event.keyCode == 13 || event.which == 13) {
      $("#wizzy-search-submit").click();
      $(".Search__Close").click();
    }
  });
}

function onHoverAddToCart() {
  $(".wizzy-result-product").on({
    mouseenter: function (event) {
      let container = $(this).children(".wizzy-result-product-item");
      container.addClass("active");
    },
    mouseleave: function (event) {
      let container = $(this).children(".wizzy-result-product-item");
      container.removeClass("active");
    },
  });
}

function wizzyCcroll(){
  $(window).scroll(function(){
  // console.log("Change CSS",$('#section-header').offset().top);
    if($('#section-header').offset().top > 44){
      $('.wizzy-search-sort-wrapper').css({"top":"55px", "position":"fixed"})
      $('.wizzy-filters-mobile-entry').css({"top":"55px", "position":"fixed"})
    }
    else{
      if($('body').hasClass('wizzy-custom')){
        $('.wizzy-search-sort-wrapper').css({"top":"-31px", "position":"absolute"})
      }
      else{
        $('.wizzy-search-sort-wrapper').css({"top":"-31px", "position":"absolute"})
      }
      $('.wizzy-filters-mobile-entry').css({"top":"96px", "position":"absolute"})
    }; 
  })
}



var searchBarObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutationRecord) {
     var searchbar = document.getElementById('Search');
    if(window.screen.width < 768){
    if(searchbar.getAttribute('aria-hidden') === 'false'){
      $("#shopify-section-header").css({"zIndex":999999})
    }
    else{
      $("#shopify-section-header").css({"zIndex":"unset"})
    }      
    }

        
    });    
   });
   
   
   
var searchbarTarget = document.getElementById('Search');
searchBarObserver.observe(searchbarTarget, { attributes : true });


var sideBarObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutationRecord) {
     var sidebar = document.getElementById('sidebar-menu');
    if(window.screen.width < 768){
    if(sidebar.getAttribute('aria-hidden') === 'false'){
      $(".wizzy-search-sort-wrapper").css({"zIndex":1})
       $(".wizzy-filters-mobile-entry ").css({"zIndex":1})
    
    }
    else{
        $(".wizzy-search-sort-wrapper").css({"zIndex":30})
       $(".wizzy-filters-mobile-entry ").css({"zIndex":100000})
    
    }      
    }

        
    });    
   });
   
   
   
var sidebarTarget = document.getElementById('sidebar-menu');
sideBarObserver.observe(sidebarTarget, { attributes : true });


